var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadlightsOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 65 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2362.6,-3376.17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-622,533)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.55112e-17,1,-1,5.55112e-17,5912.6,-105.831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3019,2918C3019,2890.39 3004.45,2868 2986.5,2868C2968.55,2868 2954,2890.39 2954,2918C2954,2918 2961.45,2923 2986.17,2923C3013,2923 3019,2918 3019,2918Z",
    style: {
      fill: "none",
      stroke: "rgb(110,119,127)",
      strokeWidth: 10
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlightsOff);
export default __webpack_public_path__ + "static/media/Headlights_off.273adbd3fb571e4ccbac9eecb513ae8e.svg";
export { ForwardRef as ReactComponent };